import type { AnalyticsElementId } from "@/lib/analytics/analyticsElementId";

/**
 * Names a component-owned child under its caller's fixed base ID.
 * Suffixes describe controls, never labels, selected values, or entity IDs.
 * The normal analytics parser validates the resulting ID before it is emitted.
 */
export function deriveAnalyticsElementId(
  baseAnalyticsElementId: AnalyticsElementId,
  suffix: string,
): AnalyticsElementId {
  return `${baseAnalyticsElementId}-${suffix}`;
}
